import Swiper, { Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSliderBooks(containerId) {
    const containerSlider = $(containerId);

    const swiperRecipe = new Swiper(containerId + ' .swiper-no-padding ', {
        modules: [Navigation, Pagination, Lazy, Scrollbar],

        slidesPerView: 'auto',

        breakpoints: {
            0: {
                spaceBetween: 8,                
            },
            //md
            768: {
                spaceBetween: 24,
            },
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
    });

    swiperRecipe.on('slideChange', function () {
        // containerSlider.find('.slider-current-page').html((this.realIndex + 1).toString().padStart(2, '0'));
        containerSlider.find('.slider-current-page').html('01');
        containerSlider.find('.slider-progress .progress-fill').css('width', Math.min(this.progress * 100, 100) + '%');
    });
}

$(function () {
    $('.slider-procampo-app').each(function () {
        initializeSliderBooks('#' + $(this).attr('id'));
    });
});
